import React, { useContext, useState } from "react";
import { DirectionRight } from "@/Icons";
import { ResourceCodeEnums } from "@/api/dmp_common/interface";
import GlobalContext from "models/globalContext";
import CascaderSelectCate from "components/cascader_select_cate";
import WordList from "views/menu_layout/flow_analysis/word/analyze/word_list";
import { AnalysisTabEnums } from "views/menu_layout/flow_analysis/config";
import router from "next/router";
import { useAuth } from "@/common/hooks/use_auth";

const MarketInsight = () => {
  const { mallId, uid } = useContext(GlobalContext);
  const [hasAuth] = useAuth(ResourceCodeEnums.FLOW_ANALYSIS);
  const [cate2Id, setCate2Id] = useState<number>();

  const handleJump = (word?: string) => {
    const pageUrl = `/${ResourceCodeEnums.MARKET_INSIGHT}?menu=${ResourceCodeEnums.FLOW_ANALYSIS}&tab=${AnalysisTabEnums.WORD}`;

    if (word) {
      router.push(`${pageUrl}&word=${word}`);
    } else {
      window.open(pageUrl);
    }
  };

  const cateCallBack = (selectCateId: string[]) => {
    if (hasAuth) {
      setCate2Id(selectCateId?.[1] && Number(selectCateId?.[1]));
    }
  };

  return (
    <div className="mt-4 rounded-lg bg-white p-6">
      <div className="title mb-6 overflow-hidden">
        <span className="text-base font-semibold leading-8">市场洞察</span>
        <div className="title-tools float-right flex">
          <CascaderSelectCate
            onChange={cateCallBack}
            initFirst
            storageKey={`${mallId}_${uid}_home-market_insight-cateId`}
            allowClear={false}
          />
          <span
            className="dmp-link ml-4 flex h-8 cursor-pointer items-center text-text-black/[.65]"
            onClick={() => handleJump()}
          >
            查看更多
            <DirectionRight />
          </span>
        </div>
      </div>

      <WordList catId={cate2Id} onWord={handleJump} />
    </div>
  );
};

export default MarketInsight;
